/**
 * Animation on Scroll Handler
 * Observes elements with specific classes and adds an animation class when they come into the viewport.
 */
document.addEventListener("DOMContentLoaded", () => {
	// Constants for reusable class names
	const ACTIVE_CLASS = "animated"; // Class added to trigger animations
	const TRIGGER_CLASS = "animate-on-scroll"; // Class to identify elements to animate

	// Select all elements containing the trigger class in their class attribute
	const scrollTriggers = document.querySelectorAll(
		`[class*='${TRIGGER_CLASS}']`,
	);

	// If there are elements to observe, set up Intersection Observers for them
	if (scrollTriggers.length > 0) {
		scrollTriggers.forEach((element) => {
			observeElement(element);
		});
	}

	/**
	 * Create an Intersection Observer for the specified element with optional observer options.
	 * Adds the active class when the element enters the viewport.
	 *
	 * @param {Element} element - The DOM element to observe.
	 * @param {Object} [options] - Optional configuration for the Intersection Observer.
	 */
	function observeElement(element, options = {}) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Add the active class when the element is visible in the viewport
					entry.target.classList.add(ACTIVE_CLASS);
				}
			});
		}, options);

		// Start observing the element
		observer.observe(element);
	}
});
